export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11758.6ebc5276.jpg";